import useServiceWorker from '../../hooks/useServiceWorker'

const ServiceWorkerHandler = () => {
  useServiceWorker()

  return null
}

export default ServiceWorkerHandler
